import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";

const RolesList = () => {
    const navigate = useNavigate();

    const [rows] = useState([
        { id: 1, name: "Role 1", date: "01 March 2025", status: true },
        { id: 2, name: "Role 2", date: "01 March 2025", status: true },
        { id: 3, name: "Role 3", date: "01 March 2025", status: false },
        { id: 4, name: "Role 4", date: "01 March 2025", status: true },
        { id: 5, name: "Role 5", date: "01 March 2025", status: false },
    ]);

    return (
        <TableContainer className="table_container">
            <Table>
                <TableHead>
                    <TableRow hover>
                        <TableCell>Role Name</TableCell>
                        <TableCell>Created Date</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow hover key={row.id}>
                            <TableCell>
                                <a
                                    href="/manage-subadmin/roles/detail"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate("/manage-subadmin/roles/detail");
                                    }}
                                    className="user_block click_action"
                                >
                                    <p>
                                        <b>{row.name}</b>
                                    </p>
                                </a>

                            </TableCell>
                            <TableCell>{row.date}</TableCell>
                            <TableCell><SwitchToggle /></TableCell>
                            <TableCell>
                                <div className="table_actions v2">
                                    <Box>
                                        <IconButton
                                            onClick={() => navigate("/manage-subadmin/roles/detail")}
                                        >
                                            <img src="/static/images/eye_icon.svg" alt="view" />
                                        </IconButton>
                                    </Box>
                                    <Box>
                                        <IconButton
                                            onClick={() => navigate("/manage-subadmin/roles/add")}
                                        >
                                            <img src="/static/images/edit2_icon.svg" alt="edit" />
                                        </IconButton>
                                    </Box>
                                    <Box>
                                        <IconButton>
                                            <img src="/static/images/trash2_icon.svg" alt="delete" />
                                        </IconButton>
                                    </Box>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default RolesList;
